Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactDOMServer", {
  enumerable: true,
  get: function get() {
    return _server.default;
  }
});
Object.defineProperty(exports, "render", {
  enumerable: true,
  get: function get() {
    return _render.default;
  }
});
Object.defineProperty(exports, "ReactPortal", {
  enumerable: true,
  get: function get() {
    return _ReactPortal.default;
  }
});
Object.defineProperty(exports, "useEventListener", {
  enumerable: true,
  get: function get() {
    return _useEventListener.default;
  }
});
Object.defineProperty(exports, "useInterval", {
  enumerable: true,
  get: function get() {
    return _useInterval.default;
  }
});
Object.defineProperty(exports, "useIsMounted", {
  enumerable: true,
  get: function get() {
    return _useIsMounted.default;
  }
});
Object.defineProperty(exports, "useLiferayState", {
  enumerable: true,
  get: function get() {
    return _useLiferayState.default;
  }
});
Object.defineProperty(exports, "usePrevious", {
  enumerable: true,
  get: function get() {
    return _usePrevious.default;
  }
});
Object.defineProperty(exports, "useStateSafe", {
  enumerable: true,
  get: function get() {
    return _useStateSafe.default;
  }
});
Object.defineProperty(exports, "useThunk", {
  enumerable: true,
  get: function get() {
    return _useThunk.default;
  }
});
Object.defineProperty(exports, "useTimeout", {
  enumerable: true,
  get: function get() {
    return _useTimeout.default;
  }
});

var _process = _interopRequireDefault(require("process"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _render = _interopRequireDefault(require("./render"));

var _ReactPortal = _interopRequireDefault(require("./ReactPortal"));

var _useEventListener = _interopRequireDefault(require("./hooks/useEventListener"));

var _useInterval = _interopRequireDefault(require("./hooks/useInterval"));

var _useIsMounted = _interopRequireDefault(require("./hooks/useIsMounted"));

var _useLiferayState = _interopRequireDefault(require("./hooks/useLiferayState"));

var _usePrevious = _interopRequireDefault(require("./hooks/usePrevious"));

var _useStateSafe = _interopRequireDefault(require("./hooks/useStateSafe"));

var _useThunk = _interopRequireDefault(require("./hooks/useThunk"));

var _useTimeout = _interopRequireDefault(require("./hooks/useTimeout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */
// Egregious hack because react-dnd expects `window.process` to exist:
//
// https://github.com/react-dnd/asap/blob/b6bebeb734/src/node/asap.ts#L24
if (!window.process) {
  window.process = _process.default;
}